export default __webpack_public_path__ + "static/media/password.03b2d919.svg";